export type FormValues = {
  legalNature: string;
  establishmentFormat: string;
};

export enum LegalNatureFields {
  LEGAL_NATURE = 'legalNature',
  ESTABLISHMENT_FORMAT = 'establishmentFormat',
}
